var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');
var _ = require('underscore');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var LanguageStore = require('../stores/language_store');
var JobStore = require('../stores/job_store');

// Job Area
module.exports = React.createClass({
	
	toggleApply : function(){	
		
		console.log('click apply', this.props);
		
		//if(_.indexOf(['spotlights', 'tdorf'], this.props.env_info.name) != -1 || (LanguageStore.get('job_ad/link/connect_with_linkedin') === '' && LanguageStore.get('job_ad/link/connect_with_facebook') === '')){
		if(true){
			var manuallyFillUrl = '/'+this.props.env_info.name+'/apply/'+this.props.job.job_id;
  		
	  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != '')		{
	  			var custom_domain = this.props.env_info.custom_job_board_domain;
	  			//var url_title = (job.url_title != '') ? job.url_title : slugify(job.title);
	  			
	  			
		  		manuallyFillUrl = 'http://'+custom_domain+'/apply/'+this.props.job.job_id+'/'+slugify(this.props.job.title);
	  		}
	  		
	  		window.location.href = manuallyFillUrl;
		
		} else {

			window.scrollTo(0, 0);
			JobActions.toggleApplyPopup();
		}
	},
	
	// Render
  	render: function(){
  		
  		//console.log('apply button props', this.props);
  		
  		var classes = 'apply-button-wrapper';
  		
  		if(typeof this.props.force_display != 'undefined'){
	  		classes += ' force-display';
  		}
  		
  		// apply_button
  		var apply_button_classes = "apply-button";
  		var apply_button_text = LanguageStore.get('job_ad/link/interested');
  		var apply_button_icon = '';
  		
  		/*if(typeof this.props.job.custom_apply_text != 'undefined' && this.props.job.custom_apply_text != ''){
	  		apply_button_text = this.props.job.custom_apply_text;
	  		apply_button_classes += " highlighted";
	  		apply_button_icon = (<span className="icon fa fa-star"></span>);
  		}*/
  		
  		var apply_button = (<button className={apply_button_classes}>
  			{apply_button_icon}
  			{apply_button_text}
  		</button>);
  		
  		if(true){
	  		
	  		var manuallyFillUrl = '/'+this.props.env_info.name+'/apply/'+this.props.job.job_id;
	  		
	  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != '')		{
	  			var custom_domain = this.props.env_info.custom_job_board_domain;
	  			//var url_title = (job.url_title != '') ? job.url_title : slugify(job.title);
	  			
	  			
		  		manuallyFillUrl = 'http://'+custom_domain+'/apply/'+this.props.job.job_id+'/'+slugify(this.props.job.title);
	  		}
	  		
	  		if(this.props.job.override_job_url && this.props.job.override_job_url !== ''){
		  		manuallyFillUrl = this.props.job.override_job_url;
	  		}
	  		
	  		if(this.props.job.webform_id && this.props.job.webform_id !== 0){
		  		manuallyFillUrl = this.props.job.apply_url;
	  		}
	  		
	  		return (
	   			<a href={manuallyFillUrl} className={classes}>
	   				{apply_button}
	   			</a>
		  	);
	  	}
	  	
   		/*return (
   			<div onClick={this.toggleApply} className={classes}>
   				{apply_button}
   			</div>
	  	);*/
	}
});
